<template>
  <span>
    <span
      v-for="(letter, index) in item"
      :key="index"
      :class="[{ 'sz_red--text': letter.mark === 1 && marked === true }]"
    >{{ letter.value }}</span>
  </span>
</template>

<script>
export default {
    name: 'EntranceFamilyElement',
    props: {
        item: {
            required: true,
            type: Array
        },
        marked: {
            default: true,
            type: Boolean
        }
    }
};
</script>

<style scoped></style>
